import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import React from 'react';

// Clipboard API yoksa (eski tarayıcı / güvenli olmayan bağlam) textarea ile kopyalar
const copyText = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  return new Promise((resolve, reject) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    success ? resolve() : reject();
  });
};

// Satır / kart tıklamasını tetiklemeden değeri panoya kopyalar
function CopyButton({ value, title, size, sx }) {
  const [copied, setCopied] = React.useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (value === null || value === undefined || value === '') return;
    copyText(String(value)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  };

  return (
    <Tooltip title={copied ? 'Kopyalandı' : title} placement="top">
      <IconButton
        size={size}
        onClick={handleClick}
        onMouseDown={(e) => e.stopPropagation()}
        sx={{ p: 0.5, color: copied ? 'success.main' : '#90a4ae', '&:hover': { color: '#FF9800' }, ...sx }}
      >
        {copied ? <CheckIcon sx={{ fontSize: 16 }} /> : <ContentCopyIcon sx={{ fontSize: 16 }} />}
      </IconButton>
    </Tooltip>
  );
}

CopyButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object
};

CopyButton.defaultProps = {
  title: 'Kopyala',
  size: 'small',
  sx: {}
};

export default CopyButton;
